import { openDB as S } from "idb";
import { mergeUpdates as T, Doc as V, applyUpdate as h, encodeStateVector as I, encodeStateAsUpdate as y, UndoManager as z, diffUpdate as J } from "yjs";
const j = 1, E = "affine-local";
function P(t) {
  t.createObjectStore("workspace", { keyPath: "id" }), t.createObjectStore("milestone", { keyPath: "id" });
}
let H;
async function K(t) {
  return new Promise((r) => {
    const i = indexedDB.open(t);
    let a = !0;
    i.onsuccess = function() {
      i.result.close(), a || indexedDB.deleteDatabase(t), r(a);
    }, i.onupgradeneeded = function() {
      a = !1;
    };
  });
}
async function Q(t, r, i = E) {
  do
    if (!H || localStorage.getItem(`${i}-migration`) !== "true") {
      try {
        H = await indexedDB.databases();
      } catch {
        if (await K(r)) {
          await S(r, 1).then(async (a) => {
            if (!a.objectStoreNames.contains("updates"))
              return;
            const s = await a.transaction("updates", "readonly").objectStore("updates").getAll();
            if (!Array.isArray(s) || !s.every((f) => f instanceof Uint8Array))
              return;
            const n = T(s), u = t.transaction("workspace", "readwrite").objectStore("workspace");
            await u.get(r) || (console.log("upgrading the database"), await u.put({
              id: r,
              updates: [
                {
                  timestamp: Date.now(),
                  update: n
                }
              ]
            }));
          });
          break;
        }
      }
      await Promise.all(
        H.map((a) => {
          if (a.name && a.version === 1) {
            const w = a.name, s = a.version;
            return S(w, s).then(
              async (n) => {
                if (!n.objectStoreNames.contains("updates"))
                  return;
                const d = await n.transaction("updates", "readonly").objectStore("updates").getAll();
                if (!Array.isArray(d) || !d.every((A) => A instanceof Uint8Array))
                  return;
                const f = T(d), g = t.transaction("workspace", "readwrite").objectStore("workspace");
                await g.get(w) || (console.log("upgrading the database"), await g.put({
                  id: w,
                  updates: [
                    {
                      timestamp: Date.now(),
                      update: f
                    }
                  ]
                }));
              }
            );
          }
        })
      ), localStorage.setItem(`${i}-migration`, "true");
      break;
    }
  while (!1);
}
async function ee(t, r = E) {
  const s = await (await S(r, j, {
    upgrade: P
  })).transaction("workspace", "readonly").objectStore("workspace").get(t);
  return s ? T(s.updates.map(({ update: n }) => n)) : !1;
}
const v = Symbol("indexeddb-provider-origin"), M = Symbol("snapshot-origin");
let $ = 500;
const L = (t) => (t.preventDefault(), t.returnValue = "Data is not saved. Are you sure you want to leave?"), U = async (t) => {
  window.addEventListener("beforeunload", L, {
    capture: !0
  }), await t, window.removeEventListener("beforeunload", L, {
    capture: !0
  });
};
function te(t) {
  $ = t;
}
function ae(t, r, i) {
  const a = new V();
  h(a, r, M);
  const w = I(t), s = I(a), n = y(
    t,
    s
  ), u = new z(
    [...a.share.keys()].map((f) => {
      const g = i(f);
      if (g === "Text")
        return a.getText(f);
      if (g === "Map")
        return a.getMap(f);
      if (g === "Array")
        return a.getArray(f);
      throw new Error("Unknown type");
    }),
    {
      trackedOrigins: /* @__PURE__ */ new Set([M])
    }
  );
  h(a, n, M), u.undo();
  const d = y(
    a,
    w
  );
  h(t, d, M);
}
class R extends Error {
  constructor() {
    super("Early disconnect");
  }
}
class X extends Error {
  constructor() {
    super("Cleanup when connecting");
  }
}
const ne = async (t, r, i, a = E) => {
  const n = (await S(a, j, {
    upgrade: P
  })).transaction("milestone", "readwrite").objectStore("milestone"), u = await n.get("id"), d = y(r);
  u ? (u.milestone[i] = d, await n.put(u)) : await n.put({
    id: t,
    milestone: {
      [i]: d
    }
  });
}, re = async (t, r = E) => {
  const s = await (await S(r, j, {
    upgrade: P
  })).transaction("milestone", "readonly").objectStore("milestone").get(t);
  return s ? s.milestone : null;
}, se = (t, r, i = E) => {
  let a, w, s = !0, n = !1;
  const u = S(i, j, {
    upgrade: P
  }), d = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), x = (o, e) => {
    if (d.has(e))
      return d.get(e);
    const c = async function(l, b) {
      const D = await u;
      if (!n || b === v)
        return;
      const k = D.transaction("workspace", "readwrite").objectStore("workspace");
      let p = await k.get(o);
      if (p || (p = {
        id: o,
        updates: []
      }), p.updates.push({
        timestamp: Date.now(),
        update: l
      }), p.updates.length > $) {
        const F = p.updates.map(({ update: C }) => C), B = new V();
        B.transact(() => {
          F.forEach((C) => {
            h(B, C, v);
          });
        }, v);
        const N = y(B);
        p = {
          id: o,
          updates: [
            {
              timestamp: Date.now(),
              update: N
            }
          ]
        }, await U(k.put(p));
      } else
        await U(k.put(p));
    };
    return d.set(e, c), c;
  }, A = (o, e) => {
    if (f.has(e))
      return f.get(e);
    const c = async function() {
      (await u).close();
    };
    return f.set(e, c), c;
  }, W = (o, e) => {
    if (g.has(e))
      return g.get(e);
    const c = async function(l) {
      l.removed.forEach((b) => {
        O(b.guid, b);
      }), l.loaded.forEach((b) => {
        _(b.guid, b);
      });
    };
    return g.set(e, c), c;
  };
  function _(o, e) {
    e.on("update", x(o, e)), e.on("destroy", A(o, e)), e.on("subdocs", W(o, e));
  }
  function O(o, e) {
    e.subdocs.forEach((c) => {
      O(c.guid, c);
    }), e.off("update", x(o, e)), e.off("destroy", A(o, e)), e.off("subdocs", W(o, e));
  }
  async function q(o, e) {
    const c = await u, m = c.transaction("workspace", "readwrite").objectStore("workspace"), l = await m.get(o);
    if (n)
      if (!l)
        await U(
          c.put("workspace", {
            id: o,
            updates: [
              {
                timestamp: Date.now(),
                update: y(e)
              }
            ]
          })
        );
      else {
        const b = l.updates.map(({ update: p }) => p), D = new V();
        D.transact(() => {
          b.forEach((p) => {
            h(D, p);
          });
        }, v);
        const k = J(
          y(e),
          y(D)
        );
        await U(
          m.put({
            ...l,
            updates: [
              ...l.updates,
              {
                timestamp: Date.now(),
                update: k
              }
            ]
          })
        ), e.transact(() => {
          b.forEach((p) => {
            h(e, p);
          });
        }, v);
      }
  }
  const G = {
    connect: async () => {
      if (n)
        return;
      G.whenSynced = new Promise((c, m) => {
        s = !0, a = c, w = m;
      }), n = !0, _(t, r);
      const o = await u;
      if (await Q(o, t, i), !n)
        return;
      const e = [];
      for (e.push([t, r]); e.length > 0; ) {
        const [c, m] = e.pop();
        await q(c, m), m.subdocs.forEach((l) => {
          e.push([l.guid, l]);
        });
      }
      s = !1, a();
    },
    disconnect() {
      n = !1, s && w(new R()), O(t, r);
    },
    async cleanup() {
      if (n)
        throw new X();
      await (await u).delete("workspace", t);
    },
    whenSynced: Promise.resolve(),
    get connected() {
      return n;
    }
  };
  return G;
};
export {
  X as CleanupWhenConnectingError,
  E as DEFAULT_DB_NAME,
  R as EarlyDisconnectError,
  se as createIndexedDBProvider,
  j as dbVersion,
  ee as downloadBinary,
  re as getMilestones,
  ne as markMilestone,
  ae as revertUpdate,
  te as setMergeCount,
  Q as tryMigrate,
  P as upgradeDB,
  U as writeOperation
};
//# sourceMappingURL=index.js.map
